import { render, staticRenderFns } from "./batchAttributeStyle.vue?vue&type=template&id=e3202032&scoped=true"
import script from "./batchAttributeStyle.vue?vue&type=script&lang=js"
export * from "./batchAttributeStyle.vue?vue&type=script&lang=js"
import style0 from "./batchAttributeStyle.vue?vue&type=style&index=0&id=e3202032&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3202032",
  null
  
)

export default component.exports